angular.module('callX').controller('CampaignsApplyListCtrl', ['$scope', 'CampaignsService', function($scope, CampaignsService) {

    $scope.applyCampaignsList = [];
    $scope.tableContentLoading = false;

    $scope.matchApplyStatus = function() {
        return function(campaign) {
            if(campaign.applied == false){
                return true;
            }
            return false;
        }
    };

    $scope.orderParam = 'date_added';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var fetchApplyCampaignsList = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                //console.log("data",data);
                $scope.applyCampaignsList = data.data;
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        CampaignsService.getApplyCampaignsList(callbacks);
    };

    fetchApplyCampaignsList();

}]);